<template>
    <div>
        ประเภทการจัดส่ง
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>